export { LMSLandingPageList } from './list'
